/**
 * Messages FR des formulaires
 */

module.exports = {

    text: {
        remainingCharacters: '0 characters remaining | 1 character remaining | { count } characters remaining'
    },

    select: {
        option: {
            default: 'Select a value',
            multiple: 'Select one or more values',
            network: 'Select a network',
            status: 'Select a status',
            priority: 'Select a priority',
            country: 'Select a country',
            timeZone: 'Select a time zone'
        }
    },

    file: {
        upload: {
            multiple: {
                label: 'Drag your files or click to select a file'
            },
            unique: {
                label: 'Drag your file or click to upload'
            }
        },
        extension: {
            help: 'Authorized files : { types }'
        }
    },

    searching: {
        placeholder: 'Search for...'
    },

    activitySector: {
        select: {
            default: 'Choose a sector of activity'
        },
        proposal: {
            button: {
                label: 'Add my profession/occupation',
                altLabel: 'Propose your sector of activity if you can\'t find it.'
            },
            fields: {
                sector: 'Your sector proposal'
            },
            placeholders: {
                sector: 'Medecine, IT, ...'
            },
            descriptions: {
                sector: 'Press ENTER on your keyboard to send your proposal.'
            },
            errors: {
                name: 'An error occurred while registering your request.'
            },
            success: 'Your proposal has been sent to the administrator for approval. You will be alerted of his decision at the following address { email }.'
        }
    },

    user: {
        editorialLine: {
            fields: {
                editorialLine: 'The general tone of your editorial line',
                formality: 'Formal or informal adress?',
                emoticonType: 'With or without emoji?'
            },
            labels: {
                without: 'Without',
                institutional: 'Moderate',
                emotional: 'Emotional'
            },
            hookDescriptions: {
                title: 'Example of a tagline',
                description: {
                    without: 'Gentle sunshine, longer days and warm evenings - The summer is here, and with it comes our collection of summer flower arrangements that evoke the warmth and beauty of this enchanting season. Discover our latest floral masterpiece, "Summer Glow", a vibrant mix of daisies, sunflowers and lisianthus, carefully assembled to capture the magic of summer in every petal. #CompositionEstivale #Flowers #summer #PassionateFlorist #Sunflower.',
                    institutional: 'Gentle sunshine, longer days and warm evenings 🌞✨ - The summer is here, and with it comes our collection  of summer flower arrangements that evoke the warmth and beauty of this enchanting season. Discover our latest floral masterpiece, "Summer Glow", a vibrant mix of daisies, sunflowers and lisianthus, carefully assembled to capture the magic of summer in every petal🌻🌿. #CompositionEstivale  #summer #PassionateFlorist #Sunflower',
                    emotional: 'Gentle sunshine ☀️, longer days 🌅 and warm evenings 🌙 - The summer is here, and and with it comes our collection of summer flower arrangements that evoke the warmth and beauty of this enchanting season. 🌞✨. Discover our floral masterpiece, "Summer Glow" 🌼, a vibrant mix of daisies 🌼, sunflowers 🌻 and lisianthus 🌸, carefully assembled to capture the magic of summer in every petal🌿. #CompositionEstivale #Fleurs #summer #PassionateFlorist #SunFlower'
                }
            }
        },
        graphicLine: {
            fields: {
                logo: 'Your logotype',
                files: 'Your graphic chart',
                addFile: 'Your graphic chart',
                notDisplayLogoOnGraphicalLineTemplate: 'Do not display my logo on graphic templates'
            },
            defaultTemplatePublication: {
                title: 'Your default graphic model :',
                button: {
                    edit: {
                        label: 'Edit my graphic model'
                    }
                }
            },
            button: {
                addFile: {
                    label: 'Add a file'
                }
            }
        },
        notificationSettings: {
            fieldset: {
                time: {
                    title: 'When do I want my CM to contact me about managing my social media accounts?',
                    information: 'Ex: Monday at 10am',
                    fields: {
                        dayName: 'Day of the week',
                        time: 'Time zone',
                        frequency: 'Frequency'
                    },
                    frequencies: {
                        weekly: 'Weelky',
                        fourteenDays: 'Every two weeks',
                        twentyOneDays: 'Every three weeks',
                        monthly: 'Monthly'
                    },
                    button: {
                        add: {
                            label: 'Add a slot'
                        }
                    }
                },
                medium: {
                    title: 'How do I want to be contacted?',
                    fields: {
                        medium: {
                            email: 'By e-mail',
                            sms: 'By SMS',
                            notification: 'By mobile notification'
                        },
                        email: 'Your e-mail adress',
                        phone: 'Your phone number',
                        notification: {
                            information: 'Appears with notifications and alerts on your Android phone'
                        }
                    },
                    notificationType: {
                        cmAdvise: 'Advice from our CM',
                        event: 'Reminder of important events',
                        feature: 'Tookano news and features',
                        commercialOffer: 'Tookano commercial offers'
                    }
                }

            }
        },
        society: {
            fields: {
                societyName: 'Society name',
                address: 'Address of society',
                country: 'Country',
                zipCode: 'Zip code',
                city: 'City',
                vatNumber: 'VAT Number'
            }
        }
    },

    admin: {
        // Paramètres pour le Super Admin
        superAdmin: {
            animations: {
                error: 'An error occurred while recording the animations.',
                title: 'Animation and video',
                fields: {
                    welcome: 'Welcome animation',
                    presentation: 'Presentation video'
                }
            },
            configuration: {
                loading: {
                    error: 'An error occurred while loading the configuration.'
                },
                taskUrgent: {
                    title: 'Number of credits for an urgent task',
                    error: 'An error occurred during the configuration update.',
                    fields: {
                        credits: 'Number of credits'
                    }
                },
                registrationCredits: {
                    title: 'Number of credits available for registration',
                    error: 'An error occurred during the configuration update.',
                    fields: {
                        credits: 'Number of credits'
                    }
                },
                aiCredits: {
                    title: 'Regeneration credits from an AI publication',
                    error: 'An error occurred during the configuration update.',
                    fields: {
                        hookCredits: 'Regeneration of taglines',
                        visualCredits: 'Regeneration of visuals'
                    }
                },
                takeMeetUrl: {
                    title: 'Make an appointment',
                    error: 'An error occurred during the configuration update.',
                    fields: {
                        url: 'Appointment booking URL'
                    }
                },
                trialPeriodDuration: {
                    title: 'Duration of the trial period',
                    error: 'An error occurred during the configuration update.',
                    fields: {
                        duration: 'Duration in days'
                    }
                },
                userRepositoryFilesMaxSize: {
                    title: 'Maximum size of a user\'s file directory',
                    error: 'An error occurred during the configuration update.',
                    fields: {
                        size: 'Maximum size of a user\'s file directory (in MB)'
                    }
                },
                maxThematicsGenerations: {
                    title: 'Maximum number of thematics generations per month',
                    error: 'An error occurred during the configuration update.',
                    fields: {
                        maxGenerations: 'Maximum number of generations'
                    }
                }
            },
            translation: {
                title: 'Translation Management',
                error: {
                    default: 'An error occurred while processing your request.',
                    import: 'An error occurred during import.',
                    export: 'An error occurred during export.'
                },
                fields: {
                    action: 'What do you want to do ?',
                    lang: 'Pour quelle langue ?',
                    file: 'Fichier à importer',
                    submit: {
                        import: 'Importer',
                        export: 'Exporter'
                    }
                },
                option: {
                    action: {
                        default: 'Choose the action',
                        import: 'Import a translation file',
                        export: 'Export translations'
                    },
                    lang: {
                        default: 'Choose the language'
                    }
                }
            },
            openAITest: {
                error: 'An error occurred while processing your request.',
                fields: {
                    model: 'Model',
                    prompt: 'Prompt',
                    maxTokens : 'Maximum number of tokens',
                    number: 'Number of answer choices to return',
                    temperature: 'Temperature',
                    imageQuality: 'Image quality',
                    verbosity: 'Verbosity',
                    reasoningEffort: 'Reasoning effort',
                    submit: 'Submit'
                },
                reasoningEffort: {
                    minimal: 'Donald Trump Mode',
                    none: 'Disabled',
                    low: 'Low',
                    medium: 'Medium (default)',
                    high: 'High'
                },
                verbosity: {
                    low: 'Low',
                    medium: 'Medium (default)',
                    high: 'High'
                },
                imageQuality: {
                    low: 'Low',
                    medium: 'Medium',
                    high: 'High'
                }
            },
            gemini: {
                error: 'An error occurred while processing your request.',
                fields: {
                    prompt: 'Prompt',
                    imageFormat: 'Image format',
                    model: 'Model',
                    videoDuration: 'Video duration',
                    videoResolution: 'Video resolution',
                    submit: 'Request'
                },
                models: {
                    'gemini-2-5-flash-image': 'Nano Banana',
                    'gemini-3-pro': 'Nano Banana Pro',
                    'gemini-3-1-flash-image': 'Nano Banana 2',
                    'veo-3-1': 'Veo 3.1',
                    'veo-3-1-fast': 'Veo 3.1 Fast'
                },
                videoDuration: '{ duration } seconds',
                imageFormats: {
                    horizontal: 'Landscape',
                    portrait: 'Portrait',
                    square: 'Square',
                }
            },
            '123rf': {
                error: 'An error occurred while processing your request.',
                fields: {
                    prompt: 'Prompt',
                    number: 'Number of images to search',
                    format: 'Format',
                    submit: 'Request'
                },
                formats: {
                    horizontal: 'Landscape',
                    portrait: 'Portrait',
                    square: 'Square',
                    panorama: 'Panorama'
                }
            },

            blackForestLabs: {
                error: 'An error occurred while generating the image.',
                fields: {
                    prompt: 'Prompt',
                    model: 'Model',
                    submit: 'Generate',
                    modifyImage: 'Modify image'
                }
            }
        },

        // Template d'une charte graphique
        graphicalLineTemplate: {
            create: {
                error: 'An error occurred during the creation of the graphic model.'
            },
            edit: {
                error: 'An error occurred while updating the graphic model.',
                fields: {
                    name: 'Name of the graphic model',
                    file: 'Demo image',
                    status: 'Status',
                    format: 'Format of the graphic model',
                    thematics: 'Thematics',
                    isDefault: 'Default model',
                    isDefaultSuggestion: 'Default suggestion',
                    position: 'Position',
                    theme: 'Theme'
                },
                theme: {
                    placeholder: 'Content type: practical advice, recruitment, case study, competition...'
                },
                templateFileNotSaved: 'The image has been modified but not saved. Click on the Validate button to save the changes.',
                button: {
                    goToTemplateList: {
                        label: 'Manage my branding'
                    }
                },
                templateFileNotSaved: 'The image has been modified but not saved. Click on the Validate button to save the changes.',
                addCarouselItemButton: {
                    label: 'Add an item'
                }
            }
        },

        // Gestion d'un code de promotion
        promotionCode: {
            error: 'An error occurred while saving the promotion code.',
            edit: {
                title: 'Edit promotion code { code }'
            },
            fields: {
                alphaCode: 'Code',
                startAt: 'Start at',
                endAt: 'End at',
                duration: 'Duration',
                activitySectors: 'Activity sectors',
                promotionAmount: 'Promotion Amount',
                promotionPercent: 'Promotion Percent'
            }
        },

        // Gestion des demandes de congés reçus
        requestedHolidays: {
            filters: {
                fields: {
                    searching: 'Searching agent requests'
                }
            },
            decline: {
                error: 'An error occurred while the application was being rejected.',
                fields: {
                    reason: 'Reason of your reject'
                }
            }
        },

        // Gestion des packs de crédit
        creditPacks: {
            error: {
                monthly: 'An error occurred while updating the subscription.',
                unique: 'An error occurred while updating the credit tariff.'
            },
            fields: {
                public: 'Visible everywheres',
                description: 'Description',
                image: 'Illustration',
                monthly: {
                    name: 'Subscription name',
                    paymentFrequency: 'Payment frequency',
                    unitPriceWithoutTax: 'Subscription price before tax (VAT 20%)',
                    credits: 'Credit number',
                    maxNetworks: 'Maximum number of social networks',
                    maxPublicationsByWeek: 'Number of weekly posts per social network',
                    maxGeneratingTasksIdeasByMonth: 'Maximum number of tasks ideas generations per month',
                    withTasksIdeasRobots: 'Generating tasks ideas from sources',
                    withSubjectsIdeasRobots: 'Generating subjects ideas from sources'
                },
                unique: {
                    name: 'Price name',
                    unitPriceWithoutTax: 'Unit price before tax'
                }
            },
            frequency: {
                monthly: 'Monthly',
                yearly: 'Yearly'
            },
            publicId: {
                description: 'If you wish to filter users or sectors, uncheck this box.'
            },
            visibility: {
                // Recherche d'éléments qui ne sont pas encore visés par le pack
                searching: {
                    error: 'An error occurred during the search.',
                    fields: {
                        search: {
                            label: 'Search for a user or a business sector',
                            placeholder: 'Perform a search'
                        }
                    }
                },
                // Ajout de secteurs ou d'utilisateurs ciblés
                add: {
                    error: 'An error occurred while adding data',
                    title: 'Search results'
                }
            }
        },

        // Administration des configurations de tâche
        taskConfiguration: {
            error: 'An error occurred during the configuration update.',
            fields: {
                name: 'Type of the task',
                group: 'Group',
                credits: 'Credit value',
                time: 'Time in minutes',
                image: 'Image',
                emoticon: 'Emoticon'
            },
            group: {
                edit: {
                    error: 'An error occurred while updating the group { group }.',
                    fields: {
                        name: 'Name',
                        parent: 'Parent group',
                        image: 'Image',
                        emoticon: 'Emoticon'
                    }
                },
                create: {
                    error: 'An error occurred during group creation.'
                },
                taskConfigurations: {
                    add: {
                        title: 'Linking a task configuration',
                        error: 'An error occurred during the group update.',
                        fields: {
                            taskConfiguration: 'Task configuration'
                        }
                    }
                }
            }
        },

        // Administration des vidéos
        video: {
            tutorial: {
                category: {
                    create: {
                        error: 'An error occurred while creating the category.'
                    },
                    edit: {
                        error: 'An error occurred while updating the { category } category.',
                        fields: {
                            name: 'Category name'
                        }
                    }
                },
                question: {
                    create: {
                        error: 'An error occurred while creating the question.'
                    },
                    edit: {
                        error: 'An error occurred while updating the { question } question.',
                        fields: {
                            category: 'Question category',
                            title: 'Question title',
                            description: 'Question description'
                        }
                    }
                },
                video: {
                    create: {
                        error: 'An error occurred while creating the video.'
                    },
                    edit: {
                        error: 'An error occurred while updating the { video } video.',
                        fields: {
                            question: 'Video question',
                            title: 'Video title',
                            description: 'Video description',
                            status: 'Video status',
                            url: 'Video url'
                        },
                        descriptions: {
                            url: 'URL of the form : https://www.youtube.com/embed/[video-identifier].'
                        },
                        status: {
                            enabled: 'Enabled',
                            disabled: 'Disabled'
                        }
                    }
                }
            },
            edit: {
                error: 'An error occurred while updating the video { video }.',
                fields: {
                    title: 'Title',
                    status: 'Status',
                    format: 'Format',
                    networks: 'Networks',
                    marketingObjectives: 'Marketing objectives',
                    thematics: 'Thematics',
                    video: 'Video file',
                    preview: 'Preview'
                }
            },
            create: {
                error: 'An error accured while creating the video.'
            },
            import: {
                error: 'An error accured while importing the video.',
                fields: {
                    file: 'Import file'
                },
                informations: 'You can import a CSV file with videos to insert. A model can be found at this <a href="{ address }" title="">adress</a>. The first line with headers should be conserved. The second line describes the data accepted for each field ; it must not be present in the file you submit.',
            }
        },

        // Administration des idées de publication
        publicationIdea: {
            edit: {
                error: 'An error occurred while updating the publication idea. { idea }.',
            },
            create: {
                error: 'An error accurred while creating the publication idea.'
            },
            import: {
                error: 'An error accurred while importing the publication ideas.',
                fields: {
                    file: 'Importation file'
                },
                informations: 'You can import a CSV file with publication ideas to insert. A model can be found at this <a href="{ address }" title="">adress</a>. The first line with headers should be conserved. The second line describes the data accepted for each field ; it must not be present in the file you submit.',
            }
        },

        // Idée de publication et marronnier
        publicationSuggestion: {
            edit: {
                fields: {
                    title: 'Title',
                    description: 'Description',
                    hook: 'Hook',
                    status: 'Status',
                    format: 'Format',
                    networks: 'Networks',
                    marketingObjectives: 'Marketing objectives',
                    thematics: 'Thematics',
                    preview: 'Preview',
                    publicationsFiles: {
                        list: 'Publication files',
                        item: 'File { index }'
                    }
                },
                addPublicationFile: {
                    button: {
                        label: 'Add a publication file'
                    }
                }
            }

        },

        horseChestnutEvent: {
            edit: {
                error: 'An error occurred while updating an event { event }.',
                fields: {
                    parent: 'Alternative version of the event.',
                    publicationDate: 'Date',
                    marketingObjective: 'Marketing objectives',
                    sectorial: 'Filter of the sector',
                    activitySectors: 'Activity sectors',
                    credits: 'Credit number'
                },
                credits: {
                    description: 'This is the number of credits required for the main task. (fixed creat for example).'
                },
                sectorial: {
                    universal: 'Universal',
                    sector: 'Sectorial'
                },
                activitySectors: {
                    default: 'Choose the activity sectors to filter.'
                },
            },
            create: {
                error: 'An error occurred while creating an event.'
            },
            import: {
                error: 'An error occurred while importing the evergreen event.',
                informations: 'You can import a CSF file with the evergreen events to insert. A model can be found at this <a href="{ address }" title="">adress</a>. The first line with headers should be conserved. The second line describes the accepted data for each field; it should not be present in the file you submit.',
                fields: {
                    file: 'Import File'
                }
            }
        },

        // Gestion des permissions
        permission: {
            section: {

                filters: {
                    fields: {
                        searching: 'Search for a sector by its name.'
                    }
                },
                edit: {
                    error: 'An error occurred while updating the section { name }.',
                    fields: {
                        key: {
                            label: 'Unique ID',
                            description: 'This identifier cannot be changed later.'
                        },
                        name: 'Section name'
                    },
                },
                create: {
                    title: 'Creating a new permission section',
                    error: 'An error occurred while creating the section.'
                },

                group: {
                    edit: {
                        title: 'Edit permission group { name }',
                        error: 'An error occurred while updating the group { name }.',
                        fields: {
                            name: 'Name of permission group',
                            crud: 'Group of crud permissions'
                        }
                    },
                    create: {
                        title: 'Creation of a permissions group for the section { name }',
                        error: 'An error occurred during group creation.'
                    },
                    permission: {
                        edit: {
                            title: 'Edit a permission { name }',
                            error: 'An error occurred while updating a permission { name }.',
                            warning: 'You must create a permission <em>Accord</em> to your permissions group so that it can be used in role editing.',
                            fields: {
                                key: {
                                    label: 'Unique ID',
                                    description: 'This identifier cannot be changed later. It is used to check that a role has this permission.'
                                },
                                name: 'Permission name',
                                type: 'Permission type',
                            }
                        },
                        create: {
                            title: 'Creation of a new group permission { name }',
                            error: 'An error occurred during permission creation.'
                        }
                    }
                }

            }
        },

        // Gestion des rôles
        role: {
            filters: {
                fields: {
                    searching: 'Search for a role by its name'
                }
            },
            edit: {
                error: 'An error occurred while updating the role { name }.',
                fields: {
                    name: 'Role name'
                },
            },
            create: {
                error: 'An error occurred while creating the role.'
            }
        },

        // Personnalisation de l'application
        application: {
            current: {
                edit: {
                    genericError: 'An error occurred while updating the application.',
                    fields: {
                        name: 'Interface name',
                        domain: 'Domaine name',
                        logo: 'Application logo',
                        favoriteIcon: 'Favorite icon',
                        termsOfUse: 'Terms and conditions of use',
                        privacyPolicy: 'Privacy policy',

                        privacyPolicyHtml: 'Privacy policy HTML { lang }'
                    }
                }
            }
        },

        // Gestion des mails internes
        mail: {
            filters: {
                fields: {
                    searching: 'Search for a mail by its name'
                }
            },
            edit: {
                title: 'Edition of an e-mail { name }',
                genericError: 'An error occurred while updating a mail { name }.',
                fields: {
                    name: 'E-mail name',
                    lang: 'Language',
                    contents: 'E-mail content'
                }
            }
        },

        // Liste des contacts
        contact: {
            filters: {
                fields: {
                    searching: 'Search for a contact by its name or e-mail adress'
                },
            },
            edit: {
                title: 'Contact edition { name }',
                genericError: 'An error occurred while updating an account of { name }.',
                fields: {
                    firstName: 'First name',
                    lastName: 'Last name',
                    email: 'E-mail adress',
                    role: 'Role'
                }
            },
            create: {
                title: 'Add a contact to your account',
                genericError: 'An error occurred during account creation.'
            }
        },

        // Gestion des secteurs d'activités
        activitySector: {
            filters: {
                fields: {
                    searching: 'Search an activity sector by its name'
                },
            },
            edit: {
                title: 'Edit an activity sector { name }',
                error: 'An error occurred while updating a sector { name }.',
                fields: {
                    name: 'Sector name',
                    lang: 'Language',
                    parent: 'Parent sector',
                    acceptProposal: 'Accept a proposal',
                    aiSettings: {
                        editorialLine: 'Tone of the editorial line',
                        writingStyle: {
                            formality: 'Formal / Informal',
                            pronouns: 'Pronouns',
                            languageRegister: 'Language register',
                            tones: 'Tones'
                        },
                        contents: {
                            post: 'Example of a post of type { postType }',
                            prompt: 'Prompt writing style for { postType } publications'
                        },
                        thematic: {
                            name: 'Thematic name { position }',
                            subject: 'Subject { position } of the thematic { thematic }'
                        }
                    }
                },
                fieldset: {
                    contentsByLang: 'Content { lang }',
                    posts: '{ postType } post',
                    thematicsByLang: 'Thematics { lang }',
                    thematicsSubjects: 'Publications subjects of the thematic'
                },
                button: {
                    addThematic: {
                        label: 'Add a thematic'
                    },
                    addSubject: {
                        label: 'Add a subject'
                    },
                    removeThematic: {
                        altLabel: 'Remove the thematic.'
                    },
                    removeSubject: {
                        altLabel: 'Remove the subject.'
                    }
                }
            },
            create: {
                title: 'Add a sector of activity',
                error: 'An error occurred during the creation of the activity sector.'
            }
        },

        // Gestion des messages de désabonnement
        unsubscribeMessages: {
            edit: {
                title: 'Updating a message { message }',
                error: 'An error occurred while updating the message.',
                fields: {
                    message: 'Message',
                    type: 'Type',
                    enabled: 'Enabled',
                    emoticon: 'Icon'
                },
                type: {
                    unique: 'Radio',
                    multiple: 'Multiple choice',
                    free: 'Free field'
                },
                answers: {
                    title: 'Sub-response { position }',
                    button: {
                        add: {
                            label: 'Add a sub-response',
                            altLabel: 'Add a selectable response to the user'
                        }
                    },
                    countAnswered: 'No response | 1 response | { count } responses'
                }
            },
            create: {
                title: 'Adding an unsubscribe message',
                error: 'An error occurred during message creation.'
            },
        },

        // Gestion des utilisateurs
        users: {
            filters: {
                internalAgent: {
                    fields: {
                        searching: 'Find an internal agent'
                    }
                },
                externalAgent: {
                    fields: {
                        searching: 'Find an external agent'
                    }
                },
                teamManager: {
                    fields: {
                        searching: 'Find a manager'
                    }
                },
                productManager: {
                    fields: {
                        searching: 'Find a product manager'
                    }
                },
                customer: {
                    fields: {
                        searching: 'Search for a customer'
                    }
                }
            },
            planning: {
                error: 'An error occurred during the update of the { name }.',
                fieldsets: {
                    workingDays: {
                        title: 'Working days',
                        tooHours: 'The attendance time is greater than the weekly time entered.'
                    },
                    nonWorkingDays: {
                        title: 'Non-working days',
                        fields: {
                            name: 'Name*',
                            date: 'Date*'
                        },
                        addButton: {
                            label: 'Add a non-working day'
                        }
                    }
                }
            },
            fields: {
                freeSubscriptionUntil: 'Date before a subscription is required',
                firstName: 'First name',
                lastName: 'Last name',
                profileImage: 'Profile image',
                email: 'E-mail adress',
                registeredAt: 'Entry date',
                phone: 'Phone number',
                applicationLang: 'Interface language',
                languages: 'Spoken languages',
                role: 'Role',
                isTestAccount: 'This is a test account',
                subscriptionType: 'Subscription type',
                contract: {
                    type: 'Type of the contract',
                    start: 'Start of contrat',
                    end: 'End of contrat',
                    weeklyHours: 'Weekly duration',
                    nbHolidays: 'Number of holidays',
                    productivity: 'Daily productivity rate',
                },
                society: {
                    name: 'Society name',
                    summary: 'Activity summary',
                    workforce: 'Number of employees',
                    activityType: 'Activity type',
                    siteUrl: 'Link to the website',
                },
                settings: {
                    editorialLine: 'The general tone of your editorial line',
                    formality: 'Formal/informal adress',
                    emoticonType: 'Emoticon type'
                },
                credits: {
                    free: 'Credits number'
                }
            },
            tabMenu: {
                customer: {
                    basic: 'Essential information',
                    editorialGraphicLine: 'Editorial and graphic line',
                    notifications: 'Notifications'
                }
            },
            languages: {
                fr: 'French',
                en: 'English',
                es: 'Spanish',
                de: 'German'
            },
            updateRole: {
                error: 'An error occurred while updating the role.'
            },
            internalAgent: {
                fields: {
                    code: 'Agent code'
                },
                create: {
                    error: 'An error occured while creating an internal agent.'
                },
                edit: {
                    error: 'An error occured while updating an internal agent { name }.'
                }
            },
            externalAgent: {
                fields: {
                    code: 'Agent code'
                },
                create: {
                    error: 'An error occured while creating an external agent.'
                },
                edit: {
                    error: 'An error occured while updating an external agent { name }.'
                }
            },
            teamManager: {
                fields: {
                    code: 'Manager code',
                    agents: {
                        label: 'Related agents',
                        placeholder: 'Search for an agent to attach to the manager'
                    }
                },
                create: {
                    error: 'An error occurred during manager creation.'
                },
                edit: {
                    error: 'An error occurred during the manager update { name }.'
                }
            },
            productManager: {
                fields: {
                    code: 'Product manager code'
                },
                create: {
                    error: 'An error occurred during the creation of the product manager.'
                },
                edit: {
                    error: 'An error occurred during the update of the product manager { name }.'
                }
            },
            customer: {
                fields: {
                    code: 'Customer code',
                    agent: {
                        label: 'Assign an agent',
                        placeholder: 'Search for an agent to assign'
                    },
                    sector: 'Activity sector and profession'
                },
                create: {
                    error: 'An error occured while creating a customer.'
                },
                edit: {
                    error: 'An error occured while updating a customer { name }.'
                },
                button: {
                    goToEditorialGraphicLine: {
                        label: 'Go to line'
                    },
                    goToNotifications: {
                        label: 'Go to notifications'
                    }
                }
            },
        },

        // Gestion des offres de coaching
        coachingOffers: {
            filters: {
                fields: {
                    searching: 'Search for a coaching offer'
                }
            },
            create: {
                error: 'An error occurred while creating the offer.'
            },
            edit: {
                error: 'An error occured while updating the offer { name }.',
                fields: {
                    name: 'Name',
                    image: 'Image',
                    summary: 'Summary',
                    details: 'Service details',
                    duration: 'Service duration',
                    credits: 'Price and credits'
                }
            }
        }
    },

    publicationSuggestion: {
        filter: {
            format: 'Filter format',
            network: 'Filter network',
            thematic: 'Filter theme',
            status: 'Filter status',
            marketingObjective: 'Filter marketing objectives'
        }
    },

    requestHolidays: {
        error: 'En error occurred while sending your request.',
        fields: {
            type: 'Holiday type*',
            begin: 'Start date*',
            end: 'End date*',
        }
    },

    account: {
        edit: {
            error: 'An error occurred while updating your account.',
            menu: {
                tabs: {
                    informations: {
                        label: 'Essential information'
                    },
                    settings: {
                        label: 'Editorial and graphic line'
                    },
                    notifications: {
                        label: 'Notifications'
                    }
                }
            },
            informations: {
                fields: {
                    profileImage: 'Profile image',
                    lastName: 'Last name',
                    firstName: 'First name',
                    email: 'E-mail adress',
                    phone: 'Phone number',
                    sector: 'Sector',
                    password: 'Password',
                    spokenLanguages: 'Spoken languages',
                    registrationDate: 'Entry date',
                    timeZone: 'Time zone',
                    trialPeriodRemainingTimeDisplayed: 'Display the remaining time of the trial period',

                    society: {
                        name: 'Name of society',
                        summary: 'Activity summary',
                        workforce: 'Number of employees',
                        activityType: 'Activity type',
                        siteUrl: 'Website'
                    }
                },
                changePasswordButton: {
                    label: 'Password reset'
                },
                credits: {
                    counter: '{ count } credit | { count } credit | { count } credits',
                    add: {
                        altLabel: 'Get more credits'
                    }
                }
            }
        },

        registration: {
            completion: {
                canNotFoundDefaultSubscription: 'Unable to determine the trial period settings.',
                error: 'An error occurred while processing your informations.',
                paymentMethodError: 'We were unable to validate your payment details.',
                fields: {
                    societyName: 'Society name',
                    activitySector: 'Activity sector',
                    network: 'Social network to manage',
                    activitySummary: 'Activity summary',
                    activityType: 'Activity type'
                },
                descriptions: {
                    activitySummary: 'You can add additional informations or edit the summary as you wish. The purpose of this summary is to help the AI better understand your business, communication style, tone of voice, and more, in order to define the editorial strategy that will be used for your communications.'
                },
                trialPeriodInformations: {
                    title: '100% free trial for { duration }',
                    underTitle: '🆓 Free · 🔓 No commitment · ↩️ Cancel anytime',
                    duration: '{ duration } of use',
                    nbPublications: 'Up to 0 post published per month | Up to 1 post published per month | Up to { count } posts published per month',
                    nbAdditionalGenerations: 'Up to 0 post idea generated per month | Up to 1 post idea generated per month | Up to { count } post ideas generated per month',
                    networks: '0 social network of your choice | 1 social network of your choice | { count } social networks of your choice',
                    about: {
                        line1: 'Add your own posts using your content, a URL, a prompt, or an image.',
                        line2: 'Create and schedule your visuals using the graphic editor and customizable templates.',
                        line3: 'Your trial period is valid for { duration }. It allows you to determine whether a tool like Tookano fits the way you want to manage your communication and integrates well into your environment.'
                    }
                },
                trialPeriodBillingInformations: {
                    title: 'Your trial period terms',
                    rule1: '🚫 No charges during your trial period.',
                    rule2: '🔔 A reminder email will be sent 7 days before the end of your trial, including the editorial calendar for the following month.',
                    rule3: '💳 Unless you take action, <strong>{ productName } subscription</strong> will start automatically <strong>at { subscriptionPrice } excluding VAT per month</strong>. It can be canceled at any time and comes with no commitment.',
                    why: 'This trial period helps us verify that an account is being created by a real person rather than an automated system. Preventing automated account creation is an important requirement for us.'
                },
                buttons: {
                    takeMeet: {
                        label: 'I want a demo first'
                    },
                    submit: {
                        label: 'Start my trial period'
                    }
                }
            }
        },

        contactsInformations: {
            error: 'An error occurred while updating your information.',
            title: 'Would you like to be alerted?',
            fields: {
                email: 'E-mail adress',
                phone: 'Phone number (to be alerted by SMS)'
            }
        },
        resetPassword: {
            error: 'An error occurred while resetting your password.',
            fields: {
                currentPassword: 'Current password',
                newPassword: 'New password',
                confirmPassword: 'Confirm password'
            }
        },
        ai: {
            validationData: {
                error: 'An error occurred during data recording.',
                loadingResources: {
                    error: 'An error occurred while loading the data.'
                },
                menu: {
                    subjects: 'Related topics and objectives',
                    generic: 'General parameters',
                    events: 'Specific posts',
                    aiSettings: 'AI Settings',
                    analysis: 'Posts customization'
                },
                fields: {
                    logo: 'Your logotype',
                    colors: 'Your dominant colors',
                    fonts: 'Your fonts',
                    networks: 'Choose 1 social network',
                    commercialName: 'Commercial name',
                    sector: 'Profession',
                    activitySummary: 'Activity summary',
                    activityType: 'Activity type',
                    events: {
                        title: 'Generate a post from the content of a url',
                        productUrl: 'Enter the URL of the web page',
                        eventUrl: 'URL of your event',
                        name: 'Name',
                        eventDate: 'Event date',
                        publicationDate: 'Publication date'
                    },
                    audiences: {
                        name: 'Target name',
                        description: 'Target description'
                    }

                },

                analysis: {
                    description: 'For even more personalization of your posts, tell us',
                    fieldsets: {
                        sources: {
                            title: 'To automate the creation of your posts'
                        },
                        taskIdeasSources: {
                            title: 'Repost',
                            description: 'Enter the URL of your blog, news page, product catalog, real estate ads, etc. Tookano will automatically retrieve the latest article, ad, or event published on this URL and create a post for each new item.'
                        },
                        notifications: {
                            title: 'Manage the frequency of my monitoring',
                            timeTitle: 'When would I like to be contacted to receive my monitoring?'
                        },
                        taskSubjectsSources: {
                            title: 'Monitoring',
                            description: 'By entering the URL below, Tookano will retrieve the latest information published on these sources and notify you at the frequency of your choice.'
                        },
                        dataUrlList: {
                            title: 'For more specific thematics and subjects on your activity'
                        },
                        writingStyle: {
                            title: 'For writing that suits you'
                        },
                        postImages: {
                            title: 'Posts based on your images',
                            description: 'Upload your own images to create personalized posts. They will be given priority if the subject of a post matches one of them. This will save you a lot of time. You can upload up to 10 images.',
                            addImageButton: {
                                label: 'Add an image'
                            }
                        }
                    },

                    titles: {
                        events: 'Analysis of your news / events'
                    },

                    fieldDescriptions: {
                        postsAccountUrl: 'Enter the URL of your account or an account that inspires you',
                        productsUrl: 'Enter your product feed URL',
                        writingStyleUrl: 'Enter the URL of your account, a post or an account/post that inspires you'
                    },
                    fields: {
                        actualitiesSectorUrl: 'Would you wish to add a news source on your activity sector?',
                        postsAccountUrl: 'Analysis of your account { network }',
                        productsUrl: 'Analysis of your products',
                        eventsUrl: 'Your blog url',
                        eventsXMLUrl: 'Your RSS feed URL',
                        writingStyleUrl: 'Analysis of the editorial style of your { network } account',
                        postImage: 'Image { index }',
                        taskIdeaSource: 'Source URL',
                        taskSubjectSource: 'Source URL { position }'
                    },
                    errors: {
                        productsUrl: 'An error occurred while parsing products. Make sure your address redirects to an XML format file.',
                        eventsXMLUrl: 'An error occurred while parsing articles. Make sure your address redirects to an XML format file.',
                        actualitiesSectorUrl: 'An error occurred while parsing actualities.'
                    },
                    maxSources: 'It is only possible to add { count } content sources at the moment.',
                    button: {
                        selectActualitiesSectorUrl: {
                            label: 'Select'
                        }
                    }
                },

                defineProductsSchema: {
                    error: 'An error occurred while processing data.',
                    types: {
                        id: 'Product identifier',
                        name: 'Product name',
                        description: 'Product description',
                        url: 'Product URL',
                        imageUrl: 'Image URL',
                        price: 'Product price',
                        weight: 'Product weight'
                    }
                },

                products: {
                    item: {
                        title: 'Product / Service / News / Event { position }'
                    }
                },
                events: {
                    item: {
                        title: 'Event { position }'
                    }
                },
                descriptions: {
                    activitySummary: 'Make sure your target buyer (persona) is clearly identified (ex : Our target personas are the marketing and communications directors of innovative companies who design industrial and medical products. / Our target persona is the individual, CSP+ aged 29 to 44, located in Bordeaux and surrounding areas). <br /> Make sure to precize the descriptions of yours services / products / solutions.',
                    sector: 'Add at least 3 letters to start your search.',
                    network: 'Choose a social network for your free plan (you can use the others later).'
                },
                titles: {
                    events: 'Would you like to see specific posts?',
                    audiences: 'Your social network targets'
                },

                audiences: {
                    item: {
                        title: 'Target { position }'
                    },
                    addButton: {
                        label: 'Add a target'
                    },
                    generateButton: {
                        label: 'Generate my targets'
                    }
                },

                buttons: {
                    colors: {
                        add: {
                            label: 'Add a color'
                        }
                    },
                    fonts: {
                        add: {
                            label: 'Add a font'
                        }
                    },
                    products: {
                        add: {
                            label: 'Add another url'
                        }
                    },
                    events: {
                        add: {
                            label: 'Add an event'
                        }
                    }
                }
            },
            validationSubjects: {
                error: 'An error occurred during data recording.',
                fields: {
                    name: 'Title',
                    marketingObjective: 'Associated objective',
                    publicationDate: 'Publication date',
                    aiThematic: 'Theme',
                    description: 'Subject description',
                    tone: 'Tone to adopt',
                    aiAudience: 'Target',
                    format: 'Format'
                },
                formats: {
                    image: 'Image',
                    carousel: 'Carousel'
                },
                period: {
                    display: 'See the subjects for the month of { month } { year }',
                    hide: 'Reduce the subjects for the month of  { month } { year }'
                },
                fieldset: {
                    subject: {
                        title: 'Subject post { index }'
                    }
                },
                description: {
                    empty: 'Specify more precisely the content of your subject.'
                },
                templates: {
                    label: 'Charter for publication',
                    goToTemplateList: {
                        label: 'Manage my branding'
                    },
                    choiceAnotherTemplate: {
                        withSelected: {
                            title: 'Choose another charter?'
                        },
                        withoutSelection: {
                            title: 'Which charter do you want to use?'
                        }
                    }
                },
                button: {
                    add: {
                        label: 'Add a topic'
                    },
                    remove: {
                        label: 'Remove a topic'
                    },
                    templates: {
                        choiceTemplate: {
                            label: 'Choose charter'
                        },
                        choiceAnotherTemplate: {
                            label: 'Choose another charter'
                        },
                        selectTemplate: {
                            altLabel: 'Use this charter.'
                        }
                    }
                }
            },
            settings: {
                error: 'An error occurred while saving your settings.',
                fieldset: {
                    editorialLine: {
                        title: 'Editorial line',
                        fields: {
                            categories: 'Categories',
                            values: 'Values',
                            format: 'Format',
                            editorialLine: 'Tone',
                            emoticon: 'With or without emoticon?'
                        },
                        button: {
                            addValue: {
                                label: 'Add a value'
                            },
                            addCategory: {
                                label: 'Add a theme'
                            }
                        }
                    },
                    graph: {
                        title: 'Graphic line',
                        fields: {
                            logo: 'Your logotype',
                            colors: 'Your dominant colors',
                            fonts: 'Your fonts'
                        }
                    },
                    contents: {
                        title: 'Posts customization',
                        fields: {
                            taskIdeaSource: 'Repost source',
                            subjectIdeaSource: 'Monitoring source { index }',
                            postsAccountUrl: 'Analysis of your account',
                            eventsUrl: 'Analysis of your news / events',
                            productsUrl: 'Analysis of your products',
                            actualitiesSectorUrl: 'News source on your activity sector'
                        },
                        descriptions: {
                            postsAccountUrl: 'Enter the URL of your account or an account that inspires you',
                            eventsUrl: 'Enter the url of your blog, news in XML format such as https://www.domainname.com/blog/feed',
                            productsUrl: 'Enter your product feed url in XML format',
                            actualitiesSectorUrl: 'Enter a URL that links to an RSS feed from a typical content source: https://www.domainname.com/news/feed'
                        },
                        withProblemGeneratingSubjectSourceUrl: 'We encountered a problem retrieving subjects from this source'
                    },
                    writingStyle: {
                        title: 'Editorial style',
                        fields: {
                            writingStyleUrl: 'For writing that suits you'
                        },
                        descriptions: {
                            writingStyleUrl: 'Enter the URL of your account, a post or an account/post that inspires you'
                        }
                    },
                    networks: {
                        title: 'Networks and frequency',
                        frequency: '{ count } posts / week'
                    },
                    aiNetworkThematics: {
                        title: 'My editorial themes',
                        edit: {
                            error: 'An error occurred while updating the theme.',
                            descriptions: {
                                name: 'Press the ENTER key on your keyboard to update the theme.',
                                subjectsProposals: 'Select subjects relevant to your business or add subjects of your choice'
                            },
                            placeholders: {
                                subjectProposal: {
                                    name: 'Indicate a subject of your choice',
                                    customerPrompt: 'Generate 5 new subjects on this thematic taking into account the following elements (indicate your request)'
                                }
                            },
                            fields: {
                                subjectsProposals: {
                                    customerPrompt: 'Ask the AI to generate new subjects by giving it as much technical detail as possible on the specifics of your business'
                                }
                            },
                            button: {
                                subjectsProposals: {
                                    generate: 'Generate'
                                }
                            }
                        },
                        add: {
                            error: 'An error occurred while adding the theme.',
                            button: {
                                label: 'Add a theme'
                            },
                            fields: {
                                name: 'Name of the theme'
                            },
                            descriptions: {
                                name: 'Press the ENTER key on your keyboard to add the theme.'
                            }
                        }
                    },

                    aiNetworkAudiences: {
                        fields: {
                            name: 'Target name',
                            description: 'Target description'
                        },
                        add: {
                            error: 'An error occurred while adding the target.',
                            button: {
                                label: 'Add a target'
                            }
                        },
                        edit: {
                            error: 'An error occurred while updating the target.',
                            title: 'Target { position }',
                            save: {
                                altLabel: 'Save the target.'
                            }
                        }
                    },

                    targeting: {
                        title: 'The target',
                        fields: {
                            description: 'Description',
                            locations: 'Location'
                        },
                        location: {
                            placeholder: 'Country, area ou city'
                        }
                    },
                    society: {
                        title: 'Society',
                        fields: {
                            activitySummary: 'Activity summary'
                        }
                    }
                },
                aiNetwork: {
                    fields: {
                        tone: 'Tone',
                        customTone: 'Customized tone'
                    },
                    placeholders: {
                        customTone: 'Ex : in the manner of Baudelaire, write in Creole, or copy and paste a text of inspiration'
                    },
                    button: {
                        editCustomTone: {
                            altLabel: 'Edit the personalised tone for the network { network }.'
                        }
                    }
                }
            },
            editPostImage: {
                error: 'An error occurred while updating the image.',
                fields: {
                    title: 'Title',
                    description: 'Description',
                    file: 'File'
                }
            },
            addPostImages: {
                error: 'An error occurred while saving.',
                fields: {
                    network: 'Network',
                    postImage: 'Image { index }'
                },
                addImageButton: {
                    label: 'Add an image'
                }
            },

            generateNewIdeasSettings: {
                error: 'An error occurred while saving.'
            }
        },
        statistics: {
            publications: {
                recommendations: {
                    title: 'What objective(s) (3 maximum) do you wish to achieve: quantified or not?',
                    error: 'An error occurred while processing the data.',
                    fields: {
                        followers: 'Increase the number of followers',
                        engagement: 'Increase engagement rate',
                        views: 'Increase views',
                        subjects: 'Vary the subjects'
                    }
                }
            },
            social: {
                accounts: {
                    period: {
                        start: 'Start date',
                        end: 'End date'
                    }
                }
            }
        },
        graphicalLineTemplate: {
            edit: {
                error: 'An error occurred in saving the graphic charter.',
                templateFileNotSaved: 'The image has been modified but not saved. Click on the Validate button to save the changes.',
                fields: {
                    name: 'Chart name',
                    thematics: 'Thematics'
                }
            }
        },

        font: {
            add: {
                error: 'An error occurred while adding the font.',
                fields: {
                    name: 'Font name',
                    file: 'Font source file',
                },
                fieldset: {
                    files: {
                        title: 'File { position }'
                    }
                },
                button: {
                    addSourceFile: {
                        label: 'Add a font file source'
                    },
                    removeSourceFile: {
                        altLabel: 'Delete this file.'
                    }
                }
            }
        },
        themes: {
            list: {
                editListButton: {
                    label: 'Manage themes'
                }
            },
            edit: {
                error: 'An error occurred while updating the theme.',
                fields: {
                    name: 'Name',
                    description: 'Description'
                }
            },
            create: {
                error: 'An error occurred while creating the theme.'
            },
            addButton: {
                label: 'Add a theme'
            }
        },
        visualIdentity: {
            error: 'An error occurred while saving the data.',
            emptyFont: 'No font found.',
            fields: {
                fonts: 'Your fonts'
            },
            button: {
                addFont: {
                    altLabel: 'Add a font.'
                }
            },
            graphicalLineTemplatesByCategory: {
                updateDefaultTemplatesError: 'An error occurred while updating the settings.',
                categories: {
                    informational: 'Informational',
                    advice: 'Advice',
                    promotional: 'Promotional'
                },
                manageButton: {
                    altLabel: 'Manage default graphic charts for publications of type { category }.',
                }
            }
        },

        postsSettings: {
            loadResourcesError: 'An error occurred while loading data.',
            error: 'An error occurred while saving the settings.',
            tabMenu: {
                global: {
                    altLabel: 'Global customization'
                }
            },
            global: {
                title: 'Global customization',
                sources: {
                    title: 'For more personalized posts'
                },
                repositoryFiles: {
                    title: 'Add your PDF documents',
                    description: 'Add your documents so the AI can better understand your business, products, and services.',
                    uploadError: 'An error occurred while processing the file.',
                    removeError: 'An error occurred while deleting the file.',
                    legal: 'By using this feature, you confirm that you own the files and agree that they may be used by AI systems to generate content.',
                    empty: 'You have not added any files.'
                }
            },
            network: {
                title: 'Customize { network }',
                fields: {
                    defaultPostType: 'Default post type',
                    formality: 'Informal / Formal tone'
                },
                defaultPostTypes: {
                    singleImage: 'Single image',
                    carousel: 'Carousel',
                    undefined: 'Mixed'
                },
                subjectsByWeek: {
                    title: 'Network posting frequency'
                },
                rulesContents: {
                    title: 'Your content guidelines',
                    fields: {
                        rule: 'Rule { position }'
                    },
                    button: {
                        add: {
                            altLabel: 'Add a content guideline for the { network } network.'
                        },
                        remove: {
                            altLabel: 'Remove this content guideline.'
                        }
                    }
                },
                targeting: {
                    title: 'Your target audiences'
                },
                thematics: {
                    title: 'Your editorial themes',
                    fields: {
                        defaultPostType: 'Default post type'
                    },
                    defaultPostTypes: {
                        singleType: 'Single image',
                        carousel: 'Carousel',
                        undefined: 'Mixed'
                    }
                }
            }
        },

        fileRepository: {
            form: {
                error: 'An error occurred while saving the file.',
                fields: {
                    file: 'File',
                    legal: 'By checking this box, you declare that you own the file and agree that it may be used by AI to generate content.',
                }
            }
        }
    },

    task: {
        list: {
            filters: {
                status: 'Status',
                taskOrigin: 'Publication type'
            }
        },
        agent: {
            transfert: {
                error: 'An error occurred while updating the task.',
                fields: {
                    agent: 'Search for an agent',
                    submit: 'Submit'
                }
            }
        },
        // Régénération de l'accroche
        regenerateHook: {
            error: 'An error has occurred while processing your request.',
            credits: '{ credits } credits will be used to generate a new hook.',
            fields: {
                subject: 'Topic',
                marketingObjective: 'Marketing objective',
                format: 'Format',
                tone: 'Tone',
                emoticonType: 'With or without emoticon?',
                prompt: 'New brief on the topic:'
            },
            placeholder: {
                prompt: 'Ex: "Generate a hook by integrating a concrete example that illustrates the topic of the post." or "Generate a longer text that includes bullet points with emojis to structure the post."' // 'Ex : "Change this tagline so that it\'s longer, with just 2 emojis and a more positive tone" or "Please create another tagline text for me with the following elements: [ describe your idea here ]'
            }
        },
        // Régénération des médias
        regenerateMedias: {
            error: 'An error has occurred while processing your request.',
            credits: '{ credits } credits will be used to generate new images.',
            fields: {
                mediaPrompt: 'Describe the visual that you want in 1 sentence'
            },
            mediaPrompt: {
                description: 'Delete the current prompt if you wish to enter your own, or generate new images using the same prompt.'
            }
        },
        // Régénération complète
        regenerate: {
            error: 'An error has occurred while processing your request',
            submit: {
                label: 'Regenerate'
            },
            fields: {
                subject: 'Post title', // 'Topic',
                marketingObjective: 'Marketing objectives',
                aiThematic: 'Theme',
                format: 'Format',
                tone: 'Tone',
                emoticonType: 'With or without emoticon?',
                prompt: 'Prompt for AI', // 'New brief on the topic:',
                keywords: 'Keywords',
                network: 'Network',
                mediaKeywords: 'Include your request in the form of keywords in English (3 max).',
                subjectDescription: 'Post details', // 'Subject description',
                aiAudience: 'Target'
            },
            tooltips: {
                subject: 'General topic covered for the post',
                subjectDescription: 'Describe the details and important information of the post that you would like the AI to address.',
                prompt: 'Provide your specific instructions so that the AI can take them into account. By default, the AI retains the previously generated text unless the post title has been modified.'
            },
            aiSubject: {
                templates: {
                    label: 'Charter for publication'
                }
            },
            formats: {
                image: 'Single image',
                carousel: 'Carousel'
            },
            description: {
                mediaKeywords:  'Ex : "cat" or "white" or "garden"'
            }
        },
        // Mise à jour d'une donnée d'une donnée d'une tâche
        updateDatum: {
            error: 'An error occurred during the data update.',
            fields: {
                publicationDate: 'Publication date'
            }
        },
        // Création d'une tâche personnalisée
        createCustom: {
            error: 'An error occurred while the task was being created.',
            tabMenu: {
                customPublication: {
                    label: 'Customized task',
                },
                events: {
                    label: 'From a content'
                },
                aiSettings: {
                    label: 'Generate a post via a prompt'
                }
            },
            fields: {
                title: 'Post title',
                date: 'Publication date',
                networks: 'Networks to post on',
                network: 'Network',
                hook: 'Tagline',
                medias: 'Publication media',
                mediasLegalAccepted: 'I have the rights to use these files.'
            },
            addMedia: {
                button: {
                    label: 'Add media'
                }
            },
            mediasLegalAccepted: {
                description: 'By ticking this box, you declare that you have the rights to these files and that you will not hold { application } responsible in the event of a conflict.'
            },
        },
        // Création en générant par l'IA
        createByAI: {
            error: 'An error has occurred while creating a task',
            tabMenu: {
                settings: {
                    label: 'Parameters',
                },
                events: {
                    label: 'Specific posts'
                }
            },
            fields: {
                publicationDate: 'Publication date'
            },
            requiredCredits: 'Your quota for generating { freeSubject } free posts per month has been reached. { creditsBySubject } credits per additional post will be used to generate your posts, i.e. { totalCredits } credits for this request.'
        },

        // Recherche d'informations pour la génération d'une tâche à partir de fichier
        searchInformationsWithFilesByIA: {
            error: 'An error occurred while parsing the files.',
            fields: {
                network: 'Network'
            },
            buttons: {
                addFile: {
                    label: 'Import an image'
                }
            }
        },

        // Paramètre pour ne plus afficher le message d'information après l'ajout d'événements personnalisés
        updateDisplayMessageSettingAfterCustomEventsAdded: {
            error: 'An error occurred while updating your account.',
            description: 'Your posts are being generated and will appear in your schedule shortly with the mention New.',
            fields: {
                setting: 'Do not display this message again'
            }
        },

        // Notation d'une tâche
        rating: {
            error: 'An error has occurred while saving your notification.',
            fields: {
                briefingMatching: 'Understanding your idea:',
                text: 'Tagline quality:',
                visual: 'Visual quality:',
                timing: 'Completion time:',
            },
            progressionLabels: {
                briefingMatching: {
                    low: 'Poor',
                    hight: 'Good'
                },
                text: {
                    low: 'Poor',
                    hight: 'Good'
                },
                visual: {
                    low: 'Poor',
                    hight: 'Good'
                },
                timing: {
                    low: 'Poor',
                    hight: 'Good'
                }
            },
            submit: {
                label: 'Save review'
            }
        },
        // Validation d'une tâche
        validate: {
            fields: {
                publishNow: 'Post now',
                schedule: 'Schedule',
                isStory: 'Publish in story',
                isFeed: 'Publish to feed'
            },
            submit: {
                save: {
                    label: 'Sauvegarder'
                }
            }
        },

        addComment: {
            error: 'An error occurred while saving your comment.',
            fields: {
                message: 'Comment',
                requestValidation: 'Request a validation',
                validate: 'Validate',
                submit: 'Comment'
            },
            placeholder: {
                comment: {
                    hook: 'Enter any comments you would like to make to the post caption here, then click "Validate" to notify your agency.',
                    visual: 'Enter any comments you would like to make regarding the post\'s visuals here, then click "Validate" to notify your agency.',
                }
            },
            button: {
                validate: {
                    hook: {
                        label: 'Validate the caption'
                    },
                    visual: {
                        label: 'Validate the visual'
                    }
                }
            }
        }
    },

    agency: {
        customer: {
            error: 'An error occurred while saving data.',
            fields: {
                societyName: 'Society name',
                email: 'Customer email used to create the account'
            },
            add: {
                title: 'Add a customer'
            },
            enable: {
                error: 'An error occurred during account activation.'
            },
            edit: {
                error: 'An error occurred while updating the account.',
                fields: {
                    role: 'Role',
                    automaticVisibleTasks: 'Publications automatically displayed to the client'
                }
            }
        },
        affiliationCodes: {
            error: 'An error occurred while saving data.',
            informations: 'By default, if you don\'t send your customer an affiliate code and they sign up on the platform with the same email, you automatically receive 20% compensation and 0% for the customer. Or, create an affiliate code to send your customer a discount:',
            fields: {
                code: 'Affiliate code name',
                agencyRemuneration: 'Agency remuneration value',
                customerPromotion: 'Customer benefit value'
            }
        }
    },

    publication: {
        comments: {
            add: {
                error: 'An error occurred while saving your comment.',
                fields: {
                    message: 'Reply to this comment',
                    submit: 'Comment'
                },
            },
            generateByAi: {
                error: 'An error occurred while generating the comment.',
                button: {
                    generate: {
                        label: 'Generate with AI'
                    }
                }
            }
        }
    }

};
